




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { newGameList } from "@/req/homes";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: Array, default: [] }) public gameList;
  @Prop({ type: Number, default: 0 }) public state;
  @Prop({ type: String, default: "" }) public parentId;
  public dataList: any = [];
  public titleStr = "";
  @Watch("gameList")
  public changeList(val) {
    if (val) {
      this.dataList = val.filter((item) => {
        return item.id == this.state;
      });
      if (this.state == 0) this.dataList = this.dataList.reverse();
      this.titleStr = this.dataList[0].date;
    }
  }
  public watchScrolls(e) {
    const parentId: any = this.$refs[this.parentId];
    const parentIdTop = parentId.getBoundingClientRect().top;
    const childList = e.target.children;
    const parentList: any = this.$parent;
    for (const item of childList) {
      const date = JSON.parse(item.dataset.obj);
      if (parentIdTop >= item.getBoundingClientRect().top) {
        this.titleStr = date;
      }
    }
  }
  public returnDate(date) {
    if (date == this.getTime(-1)) {
      return "昨天";
    } else if (date == this.getTime(0)) {
      return "今天";
    } else if (date == this.getTime(1)) {
      return "明天";
    } else {
      return date;
    }
  }
  public getTime(num) {
    const today = new Date();
    const nowTime = today.getTime();
    const ms: any = 24 * 3600 * 1000 * num;
    today.setTime(parseInt(nowTime + ms, 10));
    const oYear = today.getFullYear();
    let oMoth = (today.getMonth() + 1).toString();
    if (oMoth.length <= 1) oMoth = "0" + oMoth;
    let oDay = today.getDate().toString();
    if (oDay.length <= 1) oDay = "0" + oDay;
    return oYear + "-" + oMoth + "-" + oDay;
  }
}
